import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Button } from 'components/base';
import i18next from 'internationalization';

const TITLE = (numberOfUploadedPhotos = 0, minimumMorePhotos = 1) => {
  if (numberOfUploadedPhotos === 0) {
    if (minimumMorePhotos === 1) {
      return 'CHOOSE YOUR PHOTO';
    }
    return 'CHOOSE YOUR PHOTOS';
  }

  if (numberOfUploadedPhotos === 1) {
    if (minimumMorePhotos === 0) {
      return 'YOUR PHOTO UPLOADED!';
    }
    return '1 PHOTO UPLOADED';
  }

  return `${numberOfUploadedPhotos} PHOTOS UPLOADED!`;
};

const DESCRIPTION = (sku, numberOfUploadedPhotos, minimumMorePhotos = 0, maximumMorePhotos = 0) => {
  const howManyPhotosLabel = (min, max) => {
    if (min === 1) {
      if (max === 1) {
        return '1 photo';
      }
      return '1 photo (or more)';
    }
    if (max > min) {
      if (min <= 0) {
        return 'more photos';
      }
      return `${min} photos (or more)`;
    }
    return `${min} photos`;
  };

  if (numberOfUploadedPhotos === 0) {
    return `Upload ${howManyPhotosLabel(
      minimumMorePhotos,
      maximumMorePhotos,
    )} in JPG format, and we will take care of the rest!`;
  }

  if (minimumMorePhotos <= 0 && maximumMorePhotos > 0) {
    return 'Upload more photos if you’d like, or continue on to preview your prints. If you’d like to duplicate or delete a photo, simply tap the button in the upper right corner of the image.';
  }

  if (minimumMorePhotos > 0) {
    return `Upload at least ${minimumMorePhotos} more photos in JPG format, and we will take care of the rest! If you'd like to duplicate or delete a photo, simply tap the button in the upper right corner of the image.`;
  }

  return i18next.t(`preview_print_message.${sku}`, 'Continue to preview and edit your print.');
};

const PreviewCard = props => {
  const minimumRequiredNumberOfPhotos = props.minimumNumberOfPhotos - props.numberOfPhotos;
  const maximumRequiredNumberOfPhotos = props.maximumNumberOfPhotos - props.numberOfPhotos;

  const handleOnPreviewClick = async e => {
    await props.onFinish(e);
  };

  return (
    <Card className="text-center mx-auto mw-480 mb-5">
      <Card.Body>
        <Typography.H4 className="text-warning">
          {TITLE(props.numberOfPhotos, props.minimumNumberOfPhotos)}
        </Typography.H4>
        <Typography.P className="mb-0">
          {DESCRIPTION(
            props.sku,
            props.numberOfPhotos,
            minimumRequiredNumberOfPhotos,
            maximumRequiredNumberOfPhotos,
          )}
        </Typography.P>
        {minimumRequiredNumberOfPhotos <= 0 && (
          <Button block type="success" onClick={handleOnPreviewClick} className="mt-1">
            Preview
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

PreviewCard.propTypes = {
  sku: PropTypes.string,
  numberOfPhotos: PropTypes.number,
  minimumNumberOfPhotos: PropTypes.number,
  maximumNumberOfPhotos: PropTypes.number,
  onFinish: PropTypes.func,
};

export default PreviewCard;
